module.exports = __webpack_public_path__ + "static/media/Apple iPhone SE Rose Gold.967b6990.png";